import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

/** Slide toggle bound to a 'Yes' / 'No' string value (on = 'Yes', off = 'No'). */
@Component({
  selector: 'formly-yes-no-toggle',
  template: `
    <div class="yes-no-toggle" [class.yes-no-toggle--disabled]="formControl.disabled">
      <span class="yes-no-toggle__label">
        {{ props.label }}
        <span class="required-asterisk" *ngIf="props.required">*</span>
      </span>
      <mat-slide-toggle
        color="primary"
        labelPosition="before"
        [checked]="formControl.value === 'Yes'"
        [disabled]="formControl.disabled"
        (change)="onToggle($event.checked)"
      >
        <!-- <span class="yes-no-toggle__value">{{ formControl.value === 'Yes' ? 'Yes' : 'No' }}</span> -->
      </mat-slide-toggle>
    </div>
  `,
  styles: [
    `
      .yes-no-toggle {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        min-height: 56px;
        padding: 0 12px 0 16px;
        margin-bottom: 22px;
        border: 1px solid rgba(0, 0, 0, 0.38);
        border-radius: 4px;
        background: transparent;
      }
      .yes-no-toggle--disabled {
        opacity: 0.6;
      }
      .yes-no-toggle__label {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.87);
      }
      .yes-no-toggle__value {
        display: inline-block;
        min-width: 24px;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.6);
      }
      .required-asterisk {
        color: #f44336;
      }
    `,
  ],
})
export class YesNoToggleType extends FieldType<FieldTypeConfig> {
  onToggle(checked: boolean): void {
    this.formControl.setValue(checked ? 'Yes' : 'No');
    this.formControl.markAsDirty();
    this.formControl.markAsTouched();
  }
}
